export const BLACK = "black";
